// Records URL changes over time, so you can query what the URL was at any given time
// relative to performance.now() origin (typically page load time).
import { onUrlChange } from "./on-url-change";

type Segment = { url: string; start: number };
const segments: Segment[] = [{ url: location.href, start: 0 }];

const record = (url = location.href, report: (segment: Segment) => void) => {
    const t = performance.now();
    const last = segments[segments.length - 1];
    if (!last || last.url !== url) {
        const segment = { url, start: t };
        report(segment);
        segments.push(segment)
    };
};

let unsub: null | (() => void) = null;

// Start listening to URL changes
export const initUrlTimeline = (report: (segment: Segment) => void) => {
    if (unsub) return;
    report(segments[0]);
    unsub = onUrlChange((url) => record(url, report));
};

// Stop listening
export const stopUrlTimeline = () => {
    if (unsub) {
        unsub();
        unsub = null;
    }
};

// Get the URL that was active at the given time (relative to performance.now origin)
export const urlAt = (time: number): string => {
    for (let i = segments.length - 1; i >= 0; i--) {
        if (segments[i].start <= time) return segments[i].url;
    }
    return segments[0]?.url ?? location.href;
};

export const getHistory = () => segments.slice();

// For testing purposes - reset the state
export const __resetState = () => {
  segments.length = 0;
  segments.push({ url: location.href, start: 0 });
  if (unsub) {
    unsub();
    unsub = null;
  }
};
